// extracted by mini-css-extract-plugin
module.exports = {"indError":"indicators_indError__2-N9N","tdError":"indicators_tdError__l5imu"};